// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__17eBT","info":"UpdateTermsInfo_info__2DZTY"};